<dialog-header
  [title]="isEditMode ? 'Edit Opening Times Group' : 'Add Opening Times Group'"
  (onClose)="dialogRef.close()"
></dialog-header>

<div
  mat-dialog-content
  style="
    padding-bottom: 20px;
    border-top: 1px solid lightgray;
    border-bottom: 1px solid lightgray;
    background-color: var(--app-container);
  "
>
  <div class="form-field mb-4">
    <div class="form-field" style="margin-top: 20px">
      <div class="form-field-label">
        Group Name<span style="color: red">*</span>
      </div>
      <input
        class="form-input"
        placeholder="e.g. Drive-thru"
        autocomplete="off"
        [formControl]="nameFormControl"
        type="text"
        [ngStyle]="{
          border:
            nameFormControl.invalid && submitted
              ? '1px solid red'
              : '1px solid var(--app-light-grey)'
        }"
      />
    </div>
  </div>

  <div class="d-flex justify-content-between align-items-center mb-3">
    <div class="form-field-label">Opening Times</div>
    <mat-slide-toggle
      *ngIf="data?.country === 'United Kingdom'"
      [(ngModel)]="gmt"
    >
      <span class="section-subtitle">{{ gmt ? "GMT" : "BST" }}</span>
    </mat-slide-toggle>
  </div>

  <div class="opening-times">
    <div
      *ngFor="let day of gmt ? openingTimes : altOpeningTimes"
      class="d-flex justify-content-between align-items-center mb-2"
    >
      <div class="d-flex align-items-center">
        <mat-checkbox
          class="checkbox me-2"
          [checked]="day.active"
          (change)="toggleDay(day, $event.checked)"
        >
        </mat-checkbox>
        <p class="day-label mb-0">{{ day.day }}</p>
      </div>

      <div *ngIf="!day.active">
        <p class="day-label mb-0">Closed</p>
      </div>

      <div *ngIf="day.active" class="d-flex">
        <input
          class="small-form-input me-2"
          [formControl]="day.fromControl"
          type="time"
        />
        <input
          class="small-form-input"
          [formControl]="day.toControl"
          type="time"
        />
      </div>
    </div>
  </div>
</div>

<div mat-dialog-actions align="end">
  <app-secondary-button
    style="margin-right: 10px"
    [title]="'Cancel'"
    [disabled]="false"
    (tapped)="cancel()"
  ></app-secondary-button>

  <app-primary-button
    [disabled]="!nameFormControl.value?.trim()"
    [title]="'Save'"
    (tapped)="save()"
    bgColor="var(--app-timber)"
    color="white"
  ></app-primary-button>
</div>
